import React, { useState, useEffect } from 'react';
import { Card, Typography, Modal, Table, Row, Button, Col, Input, Space } from 'antd';
import { SearchOutlined, DownloadOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import axios from 'axios';
import * as XLSX from 'xlsx';

function RollOver() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [totalClients, setTotalClients] = useState({
    feitoTrue: 0,
    feitoFalse: 0,
  });
  const [searchCriteria, setSearchCriteria] = useState({});
  const [modalTitle, setModalTitle] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${localStorage.getItem('url')}/web/keychange-tokens/`, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        
        const jsonData = response.data;
        console.log(jsonData);
        setTotalClients({
          feitoTrue: jsonData.feito_true_count,
          feitoFalse: jsonData.feito_false_count,
        });
        setData(jsonData.tokens_details);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const showModal = (isFeito) => {
    setFilteredData(data.filter(item => item.feito === isFeito));
    setModalTitle(isFeito ? 'Clientes que ja Realizaram o TID' : 'Clientes que ainda nao realizaram o  TID');
    setVisible(true);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm()}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            onClick={() => clearFilters()}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="primary"
            onClick={() => confirm()}
            size="small"
            style={{ width: 90 }}
          >
            OK
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    render: (text) =>
      searchCriteria[dataIndex] ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchCriteria[dataIndex]]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const exportToExcel = (dataToExport, fileName) => {
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  const columns = [
    {
      title: 'Meter Number',
      dataIndex: 'meter_number',
      key: 'meter_number',
      ...getColumnSearchProps('meter_number'),
    },
    {
      title: 'Token 1',
      dataIndex: 'token1',
      key: 'token1',
      ...getColumnSearchProps('token1'),
    },
    {
      title: 'Token 2',
      dataIndex: 'token2',
      key: 'token2',
      ...getColumnSearchProps('token2'),
    },
    {
      title: 'Nome do Cliente',
      dataIndex: 'nome_cliente',
      key: 'nome_cliente',
      ...getColumnSearchProps('nome_cliente'),
    },
    {
      title: 'Morada',
      dataIndex: 'morada_cliente',
      key: 'morada_cliente',
      ...getColumnSearchProps('morada_cliente'),
    },
    {
      title: 'Feito',
      dataIndex: 'feito',
      key: 'feito',
      filters: [
        { text: 'Realizado', value: true },
        { text: 'Não Realizado', value: false },
      ],
      onFilter: (value, record) => record.feito === value,
      render: (feito) => (feito ? 'Realizado' : 'Não Realizado'),
    },
  ];

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4 text-center">RollOver</h1>
      <div className="flex justify-center items-center mb-8">
        <Row gutter={16} className="w-full" style={{ marginBottom: '3%' }}>
          <Col span={12} onClick={() => showModal(true)} style={{ cursor: 'pointer' }}>
            <Card>
              <Typography className="text-center">Clientes que ja Realizaram o TID</Typography>
              <Typography className="text-center text-2xl"><strong>{totalClients.feitoTrue}</strong></Typography>
            </Card>
          </Col>
          <Col span={12} onClick={() => showModal(false)} style={{ cursor: 'pointer' }}>
            <Card>
              <Typography className="text-center">Clientes que ainda nao Realizaram o TID</Typography>
              <Typography className="text-center text-2xl"><strong>{totalClients.feitoFalse}</strong></Typography>
            </Card>
          </Col>
        </Row>
      </div>

      <Space style={{ marginBottom: 16 }}>
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          onClick={() => exportToExcel(data, 'All_Tokens')}
        >
          Exportar Todos para Excel
        </Button>
      </Space>

      <Table columns={columns} dataSource={data} rowKey="meter_number" />

      <Modal
        title={modalTitle}
        width={'80%'}
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="export" icon={<DownloadOutlined />} onClick={() => exportToExcel(filteredData, modalTitle)}>
            Exportar para Excel
          </Button>,
          <Button key="ok" type="primary" onClick={handleOk}>
            OK
          </Button>,
        ]}
      >
        <Table columns={columns} dataSource={filteredData} rowKey="meter_number" />
      </Modal>
    </div>
  );
}

export default RollOver;
